module.exports = __webpack_public_path__ + "static/media/trygg-t.d26acb9d.mp3";